import React from 'react';
import classnames from 'classnames';

const SPR25_SMT_PRINTER_DESCRIPTION = 'The Gold-Print&#153; SPR-25 benchtop manual SMT stencil printer is designed for low to medium volume surface mount prototype printed circuit board assembly runs.';

const trim = (text, length = 115) => `${text.slice(0, length)}...`;

const getDescription = (productSlug, description) => {
  switch (productSlug) {
    case 'spr-25-manual-smt-stencil-printer':
      return trim(SPR25_SMT_PRINTER_DESCRIPTION);
    default:
      return trim(description);
  }
};

const Description = (props) => {
  const { productSlug, description, inputClassName } = props;

  return (
    <div className={classnames('description-block', inputClassName)}>
      <p>
        {getDescription(productSlug, description)}
      </p>
    </div>
  );
};

export default Description;
